export const t_global_breakpoint_height_sm = {
  "name": "--pf-t--global--breakpoint--height--sm",
  "value": "0rem",
  "var": "var(--pf-t--global--breakpoint--height--sm)"
};
export default t_global_breakpoint_height_sm;